import isArray from 'lodash/isArray';

import { Query } from '../types/Query';

export const toArray = (query: Query | Query[]): Query[] =>
  isArray(query) ? query : [query];
